import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { NgxSpinnerService } from "ngx-spinner";

@Component({
  selector: 'app-confirm-page',
  templateUrl: './confirm-page.component.html',
  styleUrls: ['./confirm-page.component.scss']
})
export class ConfirmPageComponent implements OnInit {

  message;
  logo;

  constructor(private route: ActivatedRoute, private http: HttpClient, private spinner: NgxSpinnerService) {
    this.route.queryParams.subscribe(params => {
      if (params['param'] !== '') {
        this.getClientLogo(params['param']);
        this.setdDoptin(params['param']);
      }
    });
  }

  ngOnInit(): void {
      this.spinner.show();
  }

  getClientLogo(params) {
    this.http.get('https://privacy.shock-wave.it/script/request.php?operazione=wsgetlogodoptin&key=' + params).toPromise().then(res => {
      if (res['success']) {
        this.logo = res['msg'];
      }
    },
    error => {
      this.spinner.hide();
      this.message = 'Si è verificato un errore con il caricamento del logo. Prego riprovare.';
    });
  }

  setdDoptin(params) {
    this.http.post('https://privacy.shock-wave.it/script/request.php?operazione=wssetdoptin',
      {key: params }).subscribe(res => {
        this.spinner.hide();
        if (this.isValidUrl(res['msg'])) {
          window.location.href = res['msg'];
        } else {
          this.message = res['msg'];
        }
    },
    error => {
      this.spinner.hide();
      this.message = 'Si è verificato un errore con il server. Prego riprovare.';
    });
  }

  isValidUrl(string) {
    let url;

    try {
      url = new URL(string);
    } catch (_) {
      return false;
    }

    return url.protocol === "http:" || url.protocol === "https:";
  }

}



// WEBPACK FOOTER //
// /Users/andrea/Documents/Projects/SW40/landing-portale-privacy/src/app/confirm-page/confirm-page.component.ts